<template>
  <div>
    <!-- 企业客户管理 -->
    <a-card title="三方应用管理" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">

      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="appAddBtn">新增应用</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table :columns="columns" :data-source="tableData" :pagination="false">
            <template slot="action1" slot-scope="text, record">
              <a-button-group size="small">
                <a-button icon="eye" style="color: #34C759;" type="link" v-if="$authority('openApp-detail')" @click="viewBtn(record)"> 查看</a-button>
                <a-button icon="reload" style="color:red" type="link" v-if="$authority('openApp-key-refresh') " @click="refreshKeyBtn(record)"> AES Key更新
                </a-button>
                <a-button icon="plus-square" type="link" v-if="$authority('openApp-api-add') " @click="apiAddBtn(record)"> 权限新增</a-button>
              </a-button-group>
            </template>
            <template slot="refreshSecret" slot-scope="text, record">
              <div style="display: flex; align-items: center; justify-content: center;">
               <span>
                 {{ maskSecret(text) }}
               </span>

                <a-tooltip title="复制密钥">
                  <a-button type="link" icon="copy" size="small" v-if="$authority('openApp-secret-copy') " @click="copySecret(text)"/>
                </a-tooltip>
                <a-tooltip title="刷新密钥">
                  <a-button type="link" icon="reload" size="small" style="color:red" v-if="$authority('openApp-secret-refresh') "
                            @click="refreshAppSecretBtn(record)"/>
                </a-tooltip>
              </div>
            </template>


          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <a-button :disabled="paramsData.pageNo === 1" @click="Homepage">首页</a-button>
        <a-pagination v-model.trim="paramsData.pageNo" :page-size-options="pageSizeOptions" :total="total"
                      show-size-changer :page-size="paramsData.pageSize" @change="pagechange" @showSizeChange="onShowSizeChange"
                      :item-render="itemRender"/>
        <a-button @click="Trailingpage" :disabled="paramsData.pageNo === Math.ceil(total / paramsData.pageSize)" class="Trailingpage">尾页</a-button>
      </div>
    </a-card>

    <a-modal v-model="apiShowVisible" title="接口权限" @ok="apiShowVisible=false" @cancel="apiShowVisible=false" width="75%"
             :bodyStyle="{ height: 'auto', minHeight: '30vh', maxHeight: '70vh' }">
      <a-table :columns="appApiColumns" :data-source="tableApiData" :pagination="{ pageSize: 10 }" :scroll="{ y: '55vh' }">
        <template slot="apiAction" slot-scope="text, record">
          <a-button-group size="small">
            <a-button icon="delete" style="color: #34C759;" type="link" v-if="$authority('openApp-api-del')" @click="apiDelBtn(record)"> 删除</a-button>
          </a-button-group>
        </template>
      </a-table>
    </a-modal>


    <a-modal
        v-model="apiAddShowVisible"
        title="接口权限批量授权"
        width="80%"
        :bodyStyle="{ height: 'auto', minHeight: '40vh', maxHeight: '80vh', overflowY: 'auto' }"
        @ok="handleAddApiPermission"
        @cancel="apiAddShowVisible = false"
    >
      <a-input-search
          v-model="searchKeyword"
          placeholder="请输入接口地址或说明搜索"
          style="margin-bottom: 12px;"
          allow-clear
          @search="handleSearch"
      />

      <a-table
          :columns="apiColumns"
          :data-source="coreUrlList"
          :row-selection="rowSelection"
          rowKey="authUrl"
          :pagination="{ pageSize: 10 }"
          size="small"
          bordered
      />
    </a-modal>

    <a-modal v-model="appAddShowVisible" title="新增应用" @ok="handleAddApp" @cancel="appAddShowVisible = false">
      <a-form-model ref="addForm" :model="addFormData" :rules="addRules" :label-col="{ span: 6, offset: 1 }"
                    :wrapperCol="{ span: 16, offset: 1 }" :colon="false" labelAlign="left">
        <a-form-model-item label="所属机构" prop="depId">
          <DepartmentChoose
              :department-id.sync="addFormData.depId"
              :department-code.sync="addFormData.depCode"
              :default-first="false"
          />
        </a-form-model-item>
        <a-form-model-item label="渠道归属" prop="channelNo">
          <a-select v-model="addFormData.channelNo" @change="channelChange">
            <a-select-option
                v-for="item in companylist"
                :key="item.value"
                :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="应用名称" prop="appName">
          <a-input v-model="addFormData.appName" placeholder="请输入应用名称"/>
        </a-form-model-item>
        <a-form-model-item label="应用说明" prop="appNo">
          <a-input v-model="addFormData.appDesc" placeholder="请输入应用说明"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>


    <a-modal
        v-model="appViewShowVisible"
        title="查看应用详情"
        @ok="appViewShowVisible = false"
        @cancel="appViewShowVisible = false"
        :width="'80%'"
        :bodyStyle="{padding: '16px', height: '80vh', overflowY: 'auto',display: 'flex',  flexDirection: 'column',  gap: '16px' }"
    >
      <a-descriptions title="应用基本信息" bordered column="2">
        <a-descriptions-item label="渠道号">{{
            handleChannelNo(JSON.parse(this.$session.getItem('coreCompanyList')), appDetailsData?.channelNo, '1')
          }}
        </a-descriptions-item>
        <a-descriptions-item label="机构">
          <DeptInfo :dept-id=appDetailsData?.depId></DeptInfo>
        </a-descriptions-item>


        <a-descriptions-item label="应用名称">{{ appDetailsData?.appName }}</a-descriptions-item>
        <a-descriptions-item label="描述">{{ appDetailsData?.appDesc }}</a-descriptions-item>

        <a-descriptions-item label="appId">{{ appDetailsData?.appId }}</a-descriptions-item>
        <a-descriptions-item label="appSecret">{{ appDetailsData?.appSecret }}</a-descriptions-item>

        <a-descriptions-item label="状态">{{ appDetailsData?.status === 1 ? '启用' : '禁用' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ appDetailsData?.createTime }}</a-descriptions-item>

      </a-descriptions>

      <a-divider>当前激活密钥</a-divider>
      <a-descriptions bordered column="2">
        <a-descriptions-item label="密钥版本">{{ appDetailsData?.activeKey?.keyVersion }}</a-descriptions-item>
        <a-descriptions-item label="AES密钥">{{ appDetailsData?.activeKey?.aesKey }}</a-descriptions-item>

      </a-descriptions>

      <a-divider>最新Token信息</a-divider>
      <a-descriptions bordered column="1">
        <a-descriptions-item label="AccessToken">{{ appDetailsData?.token?.accessToken }}</a-descriptions-item>
        <a-descriptions-item label="有效期(s)">{{ appDetailsData?.token?.expiresIn }}</a-descriptions-item>
        <a-descriptions-item label="RefreshToken">{{ appDetailsData?.token?.refreshToken }}</a-descriptions-item>
        <a-descriptions-item label="刷新有效期(s)">{{ appDetailsData?.token?.refreshExpiresIn }}</a-descriptions-item>

      </a-descriptions>

      <a-divider>已授权API列表</a-divider>
      <a-table :columns="appApiColumns" :data-source="appDetailsData?.apis" size="small" bordered :scroll="{ y: 200 }">
        <template slot="apiAction" slot-scope="text, record">
          <a-button-group size="small">
            <a-button icon="delete" style="color: #34C759;" type="link" v-if="$authority('openApp-api-del')" @click="apiDelDaBtn(record)"> 删除</a-button>
          </a-button-group>
        </template>
      </a-table>
    </a-modal>


  </div>
</template>

<script>
import {message} from "ant-design-vue";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import DeptInfo from "@/view/components/DeptInfo.vue";
import {handleChannelNo} from "@/utils/commonMethods";

export default {
  name: 'openApp',
  components: {DepartmentChoose, DeptInfo},
  data() {
    return {


      appViewShowVisible: false,
      appDetailsData: {},


      companylist: [],

      appAddShowVisible: false,
      addFormData: {
        appNo: "",
        channelNo: "",
        depId: undefined,
        depCode: "",
        appName: "",
        appDesc: "",
      },
      addRules: {
        appName: [
          {required: true, message: '请输入应用名称', trigger: 'blur'},
        ],
        appDesc: [
          {required: true, message: '请输入应用说明', trigger: 'blur'},
        ],
        channelNo: [
          {required: true, message: '请选择渠道归属', trigger: 'change'},
        ],
        depId: [
          {required: true, message: '请选择所属机构', trigger: 'change'},
        ],

      },


      apiAddShowVisible: false,
      coreUrlList: [],
      currentAppId: '',
      selectedUrls: [],
      searchKeyword: '',
      apiColumns: [
        {title: '接口地址', dataIndex: 'authUrl', key: 'authUrl', ellipsis: true},
        {title: '说明', dataIndex: 'note', key: 'note', ellipsis: true},
      ],

      apiShowVisible: false,
      appApiColumns: [
        {
          title: "接口名称",
          dataIndex: "note",
          align: "center",
          width: 200,
          ellipsis: true,
        },
        {
          title: "接口地址",
          dataIndex: "apiPath",
          align: "center",
          width: 200,
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action1",
          width: 100,
          align: "center",
          scopedSlots: {customRender: 'apiAction'}
        }
      ],
      tableApiData: [],

      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.paramsData.pageNo - 1) * this.paramsData.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },

        {
          title: "机构",
          dataIndex: "depId",
          align: "center",
          width: 100,
          customRender: (text) => {
            return <DeptInfo dept-id={text}></DeptInfo>;
          },
        },
        {
          title: '渠道',
          dataIndex: 'channelNo',
          align: 'center',
          width: 60,
          ellipsis: true,
          customRender: (text) => {
            return handleChannelNo(JSON.parse(this.$session.getItem('coreCompanyList')), text, '1')
          },
        },
        {
          title: '应用名称',
          dataIndex: 'appName',
          align: 'center',
          width: 60,
        },
        {
          title: '应用描述',
          dataIndex: 'appDesc',
          align: 'center',
          width: 60,
        },
        {
          title: "应用编号",
          dataIndex: "appId",
          align: "center",
          width: 100,
          ellipsis: true,
        },
        {
          title: "应用密钥",
          dataIndex: "appSecret",
          align: "center",
          width: 240,
          scopedSlots: {customRender: "refreshSecret"},
        },
        {
          title: "登记时间",
          dataIndex: "createTime",
          align: "center",
          ellipsis: true,
          width: 100,
          customRender: (text) => {
            if (!text) return "---";
            return text.split("T")[0] + " " + text.split("T")[1];
          },
        },
        {
          title: "操作",
          key: "action1",
          width: 200,
          align: "center",
          scopedSlots: {customRender: 'action1'}
        }
      ],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      total: 0,
      paramsData: {

        pageNo: 1,
        pageSize: 10,
        appId: "",
        appName: "",
        appDesc: "",

      },
    };
  },
  mounted() {
    this.getTableData();
  },
  created() {
    this.getChannelList();
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedUrls,
        onChange: (selectedRowKeys) => {
          this.selectedUrls = selectedRowKeys;
        },
        getCheckboxProps: (record) => ({
          disabled: record.disabled || false,
        }),
      };
    },
  },

  methods: {
    handleChannelNo,
    // 获取渠道列表
    async getChannelList() {
      const res = await this.api.coreCompanyInfoApi();
      if (res.code !== 200) {
        this.$message.error(res.info || "获取渠道列表失败");
        return;
      }
      this.companylist = res.data.map(item => ({
        label: `${item.channelName}（${item.channelNo}）`,
        value: item.channelNo,
        info: item
      }));
      if (this.companylist.length === 1) {
        this.formData.channelNo = this.companylist[0].value;
        this.channelChange(this.formData.channelNo);
      }
    },

    channelChange(val) {
      this.companylist.forEach((item) => {
        if (Number(val) == Number(item.value)) {
          this.addFormData.appNo = item.info.appNo;
        }
      });
    },
    // 复制密钥
    copySecret(secret) {
      if (!secret) {
        this.$message.warning("暂无可复制的密钥");
        return;
      }
      navigator.clipboard.writeText(secret).then(() => {
        this.$message.success("密钥已复制到剪贴板");
      }).catch(() => {
        this.$message.error("复制失败，请手动复制");
      });
    },


    maskSecret(secret) {
      if (!secret || secret.length <= 8) {
        return secret || "";
      }
      const prefix = secret.substring(0, 4);
      const suffix = secret.substring(secret.length - 4);
      const masked = "*".repeat(secret.length - 8);
      return `${prefix}${masked}${suffix}`;
    },
    async refreshAppSecretBtn(record) {
      this.$confirm({
        title: `确认刷新应用 [${record.appName}] 的密钥吗？`,
        content: '刷新后旧密钥将失效，请确认已告知使用方。',
        okText: '确认刷新',
        cancelText: '取消',
        onOk: async () => {
          try {
            const rsp = await this.api.refreshSecretApi({appId: record.appId});
            if (rsp.code === 200) {
              this.$message.success("密钥刷新成功");

              // 刷新当前行显示，更新 appSecret
              if (rsp.data && rsp.data.appSecret) {
                record.appSecret = rsp.data;
              }
            } else {
              this.$message.warning(rsp.info || "刷新失败");
            }
          } catch (error) {
            console.error(error);
            this.$message.error("请求异常，请稍后重试");
          }
        },
        onCancel() {
          console.log("取消刷新密钥");
        },
      });
    },

    async refreshKeyBtn(record) {
      this.$confirm({
        title: `确认刷新应用 [${record.appName}] 的AES密钥吗？`,
        content: '刷新后旧AES密钥将失效，请确认已告知使用方。',
        okText: '确认刷新',
        cancelText: '取消',
        onOk: async () => {
          try {
            const rsp = await this.api.rotateKeyApi(record);
            if (rsp.code === 200) {
              this.$message.success("AES密钥刷新成功");

            } else {
              this.$message.warning(rsp.info || "刷新失败");
            }
          } catch (error) {
            console.error(error);
            this.$message.error("请求异常，请稍后重试");
          }
        },
        onCancel() {
          console.log("取消刷新AES密钥");
        },
      });
    },


    async getTableData() {
      let data = {
        pageNo: this.paramsData.pageNo,
        pageSize: this.paramsData.pageSize,
        appId: this.paramsData.appId,
        appName: this.paramsData.appName,
        appDesc: this.paramsData.appDesc,


      };
      const res = await this.api.getAppListApi(data);
      if (res.code === 200) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      } else {
        message.warning(res.info);
      }
    },

    handleQuery() {
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        pageNo: 1,
        pageSize: 10
      };
      this.getTableData();
    },

    appAddBtn() {
      this.appAddShowVisible = true;
    },

    async handleAddApp() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          console.log('提交数据：', this.addFormData); // 可替换为API调用

          try {
            const rsp = await this.api.createAppApi(this.addFormData);
            if (rsp.code !== 200) {
              this.$message.error(rsp.info);
              return;
            }
            this.$message.success('添加成功');
            this.getTableData();

            this.appAddShowVisible = false;
          } catch (e) {
            console.error(e);
            this.$message.error('提交失败，请稍后再试');
          }
        } else {
          this.$message.error('请填写必填字段');
        }
      });
    },


    async viewBtn(record) {
      console.log("viewBtn record", record);
      const rsp = await this.api.getAppDetailApi(record);
      if (rsp.code === 200) {
        this.appDetailsData = rsp.data;
        this.appViewShowVisible = true;
      } else {
        message.warning(rsp.info);
      }
    },
    async apiDelDaBtn(record) {
      const rsp = await this.api.deleAppPathApi(record);
      if (rsp.code === 200) {
        this.appDetailsData.apis = this.appDetailsData.apis.filter(item => item.apiPath !== record.apiPath);
      } else {
        message.warning(rsp.info);
      }

    },
    updateBtn(record) {
      console.log("updateBtn record", record);
      message.warning("暂不支持修改");
    },
    apiQryBtn: async function (record) {
      const rsp = await this.api.getAppApiListApi(record);
      if (rsp.code === 200) {
        this.tableApiData = rsp.data;
        this.apiShowVisible = true;
      } else {
        message.warning(rsp.info);
      }

    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].children[0].text.toLowerCase().includes(input.toLowerCase()) ||
          option.componentOptions.children[0].children[1].text.toLowerCase().includes(input.toLowerCase())
      );
    },

    async handleAddApiPermission() {
      if (!this.selectedUrls || this.selectedUrls.length === 0) {
        this.$message.warning('请至少选择一个接口进行授权');
        return;
      }

      const payload = this.selectedUrls.map(authUrl => {
        const item = this.coreUrlList.find(i => i.authUrl === authUrl);
        return {
          appId: this.currentAppId,
          apiPath: authUrl,
          note: item ? item.note : '',
        };
      });

      try {
        const res = await this.api.addAppApi(payload);
        if (res && res.code === 200) {
          this.$message.success('接口权限授权成功');
          this.apiAddShowVisible = false;
          this.selectedUrls = [];
          this.searchKeyword = '';
        } else {
          this.$message.error(res.msg || '接口权限授权失败');
        }
      } catch (e) {
        this.$message.error('接口请求异常');
      }
    },


    // 封装公共请求与过滤逻辑
    async fetchAndFilterCoreList(appId, searchKeyword = '') {
      const rsp = await this.api.getCoreUrlpi();
      if (rsp.code !== 200) {
        message.warning(rsp.info);
        return [];
      }

      let coreList = rsp.data;
      const apirsp = await this.api.getAppApiListApi({appId});

      if (apirsp.code === 200) {
        // 使用Set优化去重性能 O(n+m) -> O(1)查找
        const existingPaths = new Set(apirsp.data.map(i => i.apiPath));
        coreList = coreList.filter(item => !existingPaths.has(item.authUrl));
      }

      // 关键字过滤
      if (searchKeyword) {
        const keyword = searchKeyword.toLowerCase();
        coreList = coreList.filter(item =>
            item.note.toLowerCase().includes(keyword) ||
            item.authUrl.toLowerCase().includes(keyword)
        );
      }
      return coreList;
    },

    // 原始方法改造
    apiAddBtn: async function (record) {
      this.currentAppId = record.appId;
      this.coreUrlList = await this.fetchAndFilterCoreList(record.appId);
      this.apiAddShowVisible = true;
    },

    handleSearch: async function () {
      if (!this.currentAppId) {
        message.warning('请先选择应用');
        return;
      }
      this.coreUrlList = await this.fetchAndFilterCoreList(
          this.currentAppId,
          this.searchKeyword
      );
    },


    apiDelBtn: async function (record) {
      const rsp = await this.api.deleAppPathApi(record);
      if (rsp.code === 200) {
        this.apiQryBtn(record)
      } else {
        message.warning(rsp.info);
      }

    },


    onShowSizeChange(current, pageSize) {
      this.paramsData.pageNo = current;
      this.paramsData.pageSize = pageSize;
      this.getTableData();
    },

    pagechange(val) {
      this.paramsData.pageNo = val;
      this.getTableData();
    },

    Homepage() {
      if (this.total === 0) return;
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    Trailingpage() {
      if (this.total === 0) return;
      this.paramsData.pageNo = Math.ceil(this.total / this.paramsData.pageSize);
      this.getTableData();
    },

    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;

  /deep/ .item {
    margin-bottom: 20px;
    margin-right: 20px;

    // span {
    //   margin-right: 15px;
    // }
    .ant-input {
      width: 200px;
      margin-left: 20px;
    }

    .ant-select {
      width: 200px;
      margin-left: 20px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 20px;
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;

  // .ant-pagination-options {
  //   float: left;
  // }

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    border: 1px solid #d9d9d9;
    width: 60px;
  }
}
</style>
